var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.00001H3.5C2.96957 4.00001 2.46086 4.21073 2.08579 4.5858C1.71071 4.96087 1.5 5.46958 1.5 6.00001V20C1.5 20.5304 1.71071 21.0392 2.08579 21.4142C2.46086 21.7893 2.96957 22 3.5 22H17.5C18.0304 22 18.5391 21.7893 18.9142 21.4142C19.2893 21.0392 19.5 20.5304 19.5 20V13M18 2.50001C18.3978 2.10219 18.9374 1.87869 19.5 1.87869C20.0626 1.87869 20.6022 2.10219 21 2.50001C21.3978 2.89784 21.6213 3.4374 21.6213 4.00001C21.6213 4.56262 21.3978 5.10219 21 5.50001L11.5 15L7.5 16L8.5 12L18 2.50001Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d1938ef8ced2ac7a8546b7f92b535cbc.svg";
export { ForwardRef as ReactComponent };